import PageLayout from '../../../components/organismes/PageLayout/PageLayout'
import { CreateTeam } from '../../../features/team/components/CreateTeam'

export default function CreateTeamPage() {
  return (
    <PageLayout 
      title="Nouvelle équipe"
      showBackButton
    >
      <div>
        <CreateTeam.CreateTeamForm />
      </div>
    </PageLayout>
  )
}
